import Select from 'component/atom/forms/select/select/Select';
import React, { useEffect } from 'react';
import styles from '../CaptureForm.module.scss';
import Toggle from 'component/atom/forms/toggle/Toggle';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import Input from 'component/atom/forms/input/input/Input';
import Button from 'component/atom/forms/button/Button';

const EntireUserReply = ({ formik, data, isFetching }) => {
  const typeOptions = data?.data?.items?.map((item) => ({
    value: item.variableId,
    label: item.variableName,
  }));

  useEffect(() => {
    if (formik.values.hasAIGenerated) {
      const current = formik.values.suggestedQuestions || [];
      if (current.length > 0) {
        formik.setFieldValue('suggestedQuestions', []);
      }
    }
  }, [formik.values.hasAIGenerated]);

  const handleVariableChange = (e) => {
    const raw = e.target.value;

    if (raw === '' || raw === null || raw === undefined) {
      formik.setFieldValue('variableId', null);
      return;
    }

    const next = Number(raw);
    formik.setFieldValue('variableId', Number.isNaN(next) ? null : next);
  };

  return (
    <div className={styles['entire-reply']}>
      <Select
        label='Variable'
        placeholder='Select Variable'
        options={typeOptions}
        name='variableId'
        value={formik.values.variableId ?? ''}
        onChange={handleVariableChange}
        error={formik.errors.variableId}
        touched={formik.touched.variableId}
        isLoading={isFetching}
      />

      <div className={styles.suggest}>
        <p>Suggestions</p>
        <Toggle
          name='hasSuggestions'
          value={formik.values.hasSuggestions || false}
          onToggleChange={() => {
            formik.setFieldValue(
              'hasSuggestions',
              !formik.values.hasSuggestions,
            );
          }}
        />
      </div>

      <div className={styles.suggest}>
        <p>AI Generated Question</p>
        <Toggle
          name='hasAIGenerated'
          value={formik.values.hasAIGenerated || false}
          onToggleChange={() => {
            const next = !formik.values.hasAIGenerated;
            formik.setFieldValue('hasAIGenerated', next);

            if (next) {
              formik.setFieldValue('suggestedQuestions', []);
            }
          }}
        />
      </div>

      <div className={styles['label-container']}>
        <p className={styles['label']}>Predefined Suggestions</p>

        <Button
          type='plus'
          transparent
          buttonType='button'
          disabled={
            !!formik.values.hasAIGenerated ||
            (formik.values.suggestedQuestions || []).length >= 4
          }
          onClick={() => {
            if (formik.values.hasAIGenerated) return;

            formik.setFieldValue('suggestedQuestions', [
              ...(formik.values.suggestedQuestions || []),
              { question: '' },
            ]);
          }}
          className={styles['button']}
        />
      </div>

      {(formik.values.suggestedQuestions || []).map((variant, index) => (
        <div className={styles['multi-input']} key={index}>
          <Input
            name={`suggestedQuestions.${index}.question`}
            value={variant?.question}
            onChange={formik.handleChange}
            errors={formik.errors?.suggestedQuestions?.[index]?.question}
            touched={formik.touched?.suggestedQuestions?.[index]?.question}
            placeholder='Enter a question'
            maxLength='30'
          />

          <div className={styles['variant-action']}>
            <SvgWithBranding
              type='delete2'
              className={styles.icon}
              onClick={() => {
                const updated = (formik.values.suggestedQuestions || []).filter(
                  (_, i) => i !== index,
                );
                formik.setFieldValue('suggestedQuestions', updated);
              }}
            />
          </div>
        </div>
      ))}

      <div className={styles.suggest}>
        <p>Reassess Intent</p>
        <Toggle
          name='reassessIntent'
          value={formik.values.reassessIntent || false}
          onToggleChange={() => {
            formik.setFieldValue(
              'reassessIntent',
              !formik.values.reassessIntent,
            );
          }}
        />
      </div>
    </div>
  );
};

export default EntireUserReply;
